import axios from "../config/axios";
import Constants from "../data/Constants";

export const getMentorVerificationList = async (pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.MENTOR_VERIFICATION.ALL)
    .then((res) => {
      return res.data.result;
    });
};

export const setMentorVerificationStatusApi = async (id, data) => {
  await axios
    .post(Constants.ENDPOINTS.MENTOR_VERIFICATION.UPDATE_STATUS + id, data)
    .then((res) => {
      return res.data.result;
    });
};

export const updateMentorVerification = async (id, data) => {
  return await axios
    .patch(
      Constants.ENDPOINTS.MENTOR_VERIFICATION.UPDATE + id,
      JSON.stringify(data)
    )
    .then((res) => {
      return res.data.result;
    });
};
